import classNames from 'classnames';
import React from 'react';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import { useSearchContext } from '@/libraries/contexts/search-context';
import styles from './search-bar-brand-selector-button.module.scss';

const brandMap: Record<
  Exclude<Content.Properties.Brand, 'gruppe' | 'safari'>,
  { headline: string; icon: IconName }
> = {
  default: {
    headline: 'Sol',
    icon: 'Sun',
  },
  golf: {
    headline: 'Bravo Golf',
    icon: 'Golf',
  },
  rejseklubben: {
    headline: 'Rejseklubben',
    icon: 'Luggage',
  },
  // Removing safari as per request, but keeping the code for future use
  // safari: {
  //   headline: 'Bravo Safari',
  //   icon: 'Safari',
  // },
};

export interface SearchBarBrandSelectorButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** The class name to apply */
  className?: string;
  /** Indicates whether the field is disabled */
  disabled?: boolean;
  /** Indicates whether the field is active */
  isActive?: boolean;
  /** Indicates whether the field is notified that has changes */
  isNotified?: boolean;
  /** An event that is triggered on click */
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
}

const SearchBarBrandSelectorButton = ({
  className,
  disabled = false,
  isActive = false,
  isNotified = false,
  ...rest
}: SearchBarBrandSelectorButtonProps) => {
  const { brand } = useSearchContext();

  return (
    <button
      {...rest}
      className={classNames(styles.component, className, {
        [styles.isActive]: isActive,
        [styles.isDisabled]: disabled,
        [styles.isNotified]: isNotified,
      })}
      tabIndex={0}
    >
      <div className={styles.brandContent}>
        <div className={styles.brandHeader}>
          <Icon name={brandMap[brand].icon} size={24} />

          <Typography tagStyle="bodySmallBold">
            {brandMap[brand].headline}
          </Typography>
        </div>

        <Icon
          aria-hidden="true"
          className={styles.brandChevron}
          name="ChevronDown"
          size={14}
        />
      </div>
    </button>
  );
};

SearchBarBrandSelectorButton.displayName = 'SearchBarBrandSelectorButton';

export default SearchBarBrandSelectorButton;
